import PropTypes from 'prop-types';
import cx from 'classnames';
import { CatIconChevronDown } from '@blocks-react/components/Icons/ChevronDown';
import { CatIconChevronUp } from '@blocks-react/components/Icons/ChevronUp';
import styles from './StickyCTA.module.scss';

const StickyCTAHeader = ({
  isExpandable = false,
  isExpanded = false,
  onExpanderClick = () => null,
  children = ''
}) => {
  const expanderIcon = isExpanded ? (
    <CatIconChevronUp size="sm" data-testid="StickyCTAHeaderExpanderIconUp" />
  ) : (
    <CatIconChevronDown
      size="sm"
      data-testid="StickyCTAHeaderExpanderIconDown"
    />
  );
  return (
    <div className="d-flex align-items-center w-100">
      {isExpandable && (
        <button
          className={cx(
            styles['cat-bg-default'],
            'p-0 shadow-none border-0 font-weight-normal me-2'
          )}
          onClick={onExpanderClick}
          data-testid="StickyCTAHeaderExpanderButton"
          id="sticky-cta-expand-btn"
          aria-controls="sticky-cta-content"
          aria-expanded={isExpanded}
        >
          {expanderIcon}
        </button>
      )}
      <div className="flex-grow-1">{children}</div>
    </div>
  );
};

StickyCTAHeader.propTypes = {
  isExpandable: PropTypes.bool,
  isExpanded: PropTypes.bool,
  onExpanderClick: PropTypes.func,
  children: PropTypes.element
};

export default StickyCTAHeader;
